import { NAME } from './constants';
import Container from './Container';

export default {
    Container,
    NAME,
};
